import { useEffect } from "react"
import { matchPath, useLocation } from "react-router-dom"

const routeTitles = [
  { path: "/dashboard", title: "Client Portal" },
  { path: "/verify", title: "Verify Portal Access" },
  { path: "/", title: "Portal Login" },
]

function formatPageTitle(title: string) {
  return title === "Projekt" ? title : `Projekt · ${title}`
}

function getRouteTitle(pathname: string) {
  for (const route of routeTitles) {
    if (matchPath({ path: route.path, end: true }, pathname)) {
      return route.title
    }
  }

  return "Projekt"
}

export function RouteDocumentTitle() {
  const location = useLocation()

  useEffect(() => {
    document.title = formatPageTitle(getRouteTitle(location.pathname))
  }, [location.pathname])

  return null
}
